<template>
  <!-- <div>
    <div>Refer others</div>
    <div><button @click="getReferralSignUpLink">Get Referral Link</button></div> -->
  <!-- <div>{{ referralSignUpLink }}</div> -->
  <!-- <input v-model="referralSignUpLink" id="copyThis" size="100" />
    <button @click="copyRefLink">Copy</button>
  </div> -->
  <div class="container pap-form">
    <div class="card">
      <FormTitle
        title="Tell Your Friends!"
        iconclass="fas fa-user-friends mr-2"
      />
      <div class="card-body">
        <b-form novalidate>
          <p class="font-weight-bold">
            Want some perks and rewards just for talking about Pixapup?
          </p>
          <div class="pap-form__text">
            <p>
              Help us spread the word! It's easy -- All you do is give your
              <strong>referral signup link</strong> (shown below) to your other
              dog-owner friends.
            </p>
            <p>
              For each person who creates a Pixapup account (remember, it's
              free!) using your link,
              <strong>you</strong> get credit for that signup as a referral (up
              to a maximum of 10 referrals to start)! ***
            </p>
            <p>
              Every so often, we will reward users who have a certain number of
              referrals.
            </p>
            <p>
              You can earn: More Image Upload slots (initially you get 10 slots
              max), a higher referral maximum (initially 10), product discounts,
              coupon codes, and more.
            </p>
            <p>
              So copy your link and send it to your family and friends who might
              like to upload pics of <strong>their</strong> dogs for inclusion
              in a book or calendar!
            </p>
          </div>

          <b-form-group
            id="reflink-group"
            label="Your Referral Sign Up Link"
            label-for="reflink"
            label-class="label-bold"
          >
            <div v-if="!refCode" class="text-center">
              <!-- <button
                type="button"
                class="btn btn-primary btn-sm my-3"
              :disabled="fetchingRefCode"

                @click="getReferralSignUpLink"
              >
                <i class="far fa-comments mr-2"></i>Get My Referral Link
              </button> -->

              <b-overlay
                :show="fetchingRefCode"
                rounded
                opacity="0.2"
                spinner-small
                spinner-variant="white"
                class="d-inline-block"
              >
                <button
                  type="button"
                  class="btn btn-primary btn-sm my-3"
                  :disabled="fetchingRefCode"
                  @click="getReferralSignUpLink"
                >
                  <i class="far fa-comments mr-2"></i>Get My Referral Link
                </button>
                <!-- <b-button
                  ref="button"
                  :disabled="fetchingRefCode"
                  variant="primary"
                  size="sm"
                  @click="getReferralSignUpLink"
                  ><i class="far fa-comments mr-2"></i>Get My Referral
                  Link</b-button
                > -->
              </b-overlay>
            </div>
            <b-form-input
              v-if="refCode"
              id="reflink"
              v-model="referralSignUpLink"
            ></b-form-input>
            <div class="text-center">
              <button
                v-if="refCode"
                :disabled="copyBtnDisabled"
                type="button"
                class="btn btn-success btn-sm mt-2"
                @click="copyRefLink"
              >
                <i class="far fa-copy mr-2"></i>{{ copyBtnText }}
              </button>

              <!-- <div class="pap-form__text mt-3">
                <p class="font-weight-bold">
                  Thank you for helping spread the word -- more people using
                  Pixapup means more dogs will find their loving forever home!
                </p>

                <p class="text-smaller-2">
                  *** Please note: Each referred signup is checked against a few
                  system rules before being credited to the user whose signup
                  link was used. Any signup deemed
                  <span class="italic">invalid</span> will not be credited to
                  the referring user. These system rules are in place to help
                  minimize potential abuse of the referrals system.
                </p>
              </div> -->
            </div>
          </b-form-group>

          <b-form-group
            class="mt-5"
            id="numrefs-group"
            label="Number of Referred Signups"
            label-for="numrefs"
            label-class="label-bold"
          >
            You can check how many Pixapup signups were referred by you. Click
            this button:
            <div class="text-center">
              <b-overlay
                :show="fetchingNumRefs"
                rounded
                opacity="0.2"
                spinner-small
                spinner-variant="white"
                class="d-inline-block"
              >
                <button
                  type="button"
                  class="btn btn-primary btn-sm my-3"
                  :disabled="fetchingNumRefs || numRefsFetchCompleted"
                  @click="getNumRefs"
                >
                  <div v-if="numRefsFetchCompleted">Done</div>
                  <div v-else>
                    <i class="fas fa-hashtag mr-2"></i>Get Signups Count
                  </div>
                </button>
              </b-overlay>
            </div>

            <div
              class="general-panel text-center text-txt-blue font-weight-bold"
            >
              Number of Pixapup signups referred by you:
              {{ displayNumSignups }}
            </div>
          </b-form-group>

          <div class="pap-form__text mt-5">
            <hr />
            <p class="font-weight-bold text-center">
              Thank you for helping spread the word -- more people using Pixapup
              means more dogs will find their loving forever home!
            </p>

            <p class="text-smaller-2 text-center">
              *** Please note: Each referred signup is checked against a few
              system rules before being credited to the user whose signup link
              was used. Any signup deemed
              <span class="italic">invalid</span> will not be credited to the
              referring user. These system rules are in place to help minimize
              potential abuse of the referrals system.
            </p>
          </div>
        </b-form>
      </div>
      <!-- end card-body -->
    </div>
  </div>
</template>

<script>
console.log(33);
function getInputFocus(inputElement) {
  return new Promise((res) => {
    inputElement.focus();
    setTimeout(function () {
      console.log(inputElement.value);
      inputElement.setSelectionRange(0, inputElement.value.length);
      // inputElement.selectionEnd = inputElement.value.length;
      res(true);
    }, 100);
  });
}
import FormTitle from '@/components/form/FormTitle';
export default {
  name: 'PageRefer',
  components: { FormTitle },
  data: function () {
    return {
      refCode: '',

      fetchingNumRefs: false,
      numRefsFetchCompleted: false,
      numRefs: null,
      // referralSignUpLink: '',
      fetchingRefCode: false,
      copyBtnText: 'Copy Link',
      copyBtnDisabled: false,
    };
  },
  computed: {
    // referralSignUpLink: function () {
    //   return this.refCode
    //     ? window.location.origin + '/signup/' + this.refCode
    //     : '';
    // },
    referralSignUpLink: function () {
      return this.refCode ? window.location.origin + '/?r=' + this.refCode : '';
    },
    displayNumSignups: function () {
      return this.numRefs === null ? '___' : this.numRefs;
    },
  },
  methods: {
    // getInputFocus: function (inputElement) {
    //   return new Promise((res) => {
    //     inputElement.focus();
    //     setTimeout(function () {
    //       console.log(inputElement.value);
    //       inputElement.setSelectionRange(3, 10);
    //       // inputElement.selectionEnd = inputElement.value.length;
    //       res(true);
    //     }, 100);
    //   });
    // },
    copyRefLink: async function () {
      // this.$refs.copyThis.select();
      var copyInput = document.getElementById('reflink');

      // .select() doesn't work on ios mobile.
      // G: input.select() doesn't work on safari?
      // One solution: https://stackoverflow.com/questions/15927118/mobile-safari-jquery-select-on-focus-input-doesn%C2%B4t-work
      // copyInput.select();
      await getInputFocus(copyInput);
      document.execCommand('copy');
      // Deselect the text in the input box - two steps
      // copyInput.value = ''; // step 1
      // copyInput.value = this.referralSignUpLink; // step 2
      // Remove focus from input after deselecting; otherwise, focus remains, i.e. cursor present -- don't want that.
      // copyInput.blur();
      var origBtnText = this.copyBtnText;
      this.copyBtnText = 'Copied!';
      this.copyBtnDisabled = true;
      setTimeout(() => {
        this.copyBtnText = origBtnText;
        this.copyBtnDisabled = false;
      }, 2000);
    },
    getRefCode: async function () {
      var refCode = await this.$fapi.firebase
        .functions()
        .httpsCallable('getRefCode')();
      this.refCode = refCode.data;
      // console.log('Referral Link', refCode.data);
    },
    getReferralSignUpLink: async function () {
      this.fetchingRefCode = true;
      var refCode = localStorage.getItem('refCode');
      if (refCode) {
        this.refCode = refCode;
      } else {
        await this.getRefCode();
        localStorage.setItem('refCode', this.refCode);
      }
      this.fetchingRefCode = false;
      // this.referralSignUpLink = ;
    },
    getNumRefs: async function () {
      this.fetchingNumRefs = true;

      try {
        var numSignups = await this.$fapi.firebase
          .functions()
          .httpsCallable('getNumReferredSignups')();
        this.numRefs = numSignups.data;
      } catch (err) {
        console.error(err.message);
      }
      this.numRefsFetchCompleted = true;
      this.fetchingNumRefs = false;
    },
  },
  created: function () {
    this.refCode = localStorage.getItem('refCode');
  },
};
</script>

<style>
</style>